import { Box, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { InfoIcon, useMinimalsTheme } from '@tom-ui/ui'
import { formatDateTime } from '@tom-ui/utils'
import dayjs from 'dayjs'
import { ContainerJourneyReportColumnDto } from '../../stores/ContainerJourneyReportViewStore'

interface ContainerJourneyDetailPanelProps {
  row: { original: ContainerJourneyReportColumnDto }
}

export const ContainerJourneyReporTableDetailPanel = ({
  row,
}: ContainerJourneyDetailPanelProps) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const services = row.original.services || []

  const renderItem = (title: string, value?: string | number | null) => {
    if (value === undefined || value === null || value === '') return null
    return (
      <Stack minWidth={200} p={2}>
        <Typography variant='subtitle2'>{title}</Typography>
        <Typography variant='body2'>{value}</Typography>
      </Stack>
    )
  }

  const renderDateWithLabel = (date?: string | null, title?: string) => {
    const d = date ? dayjs(date) : undefined

    return (
      <Stack direction='column' spacing={1} minWidth={200} p={2}>
        <Typography variant='subtitle2'>{title}</Typography>
        <Typography variant='body2'>{d ? formatDateTime(d) : '-'}</Typography>
      </Stack>
    )
  }

  return (
    <Box
      sx={{
        bgcolor: theme.palette.grey[100],
        borderTop: `1px solid ${theme.palette.divider}`,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack direction={'row'}>
        <Stack
          direction={'row'}
          p={3}
          sx={{
            left: 0,
            position: 'sticky',
            borderRight: `1px solid ${theme.palette.divider}`,
            bgcolor: theme.palette.grey[100],
            minWidth: 220,
          }}
        >
          <InfoIcon sx={{ mr: 1 }} />
          <Typography variant='subtitle2' fontWeight={600}>
            {t('servicesDetails', 'Services Details')}
          </Typography>
        </Stack>

        <Stack direction={'column'} flex={1}>
          {services.length === 0 ? (
            <Stack p={3} justifyContent='center' height='100%'>
              <Typography variant='body2' color='textSecondary'>
                {t('noServicesFound', 'No services recorded for this journey.')}
              </Typography>
            </Stack>
          ) : (
            services.map((service, index) => (
              <Stack
                key={index}
                direction='row'
                flexWrap='wrap'
                sx={{
                  borderBottom:
                    index !== services.length - 1 ? `1px solid ${theme.palette.divider}` : 'none',
                }}
              >
                {renderItem(t('serviceName', 'Service Name'), service.serviceName)}
                {renderDateWithLabel(service.startDate, t('startDate', 'Start Date'))}
                {renderDateWithLabel(service.endDate, t('endDate', 'End Date'))}
              </Stack>
            ))
          )}
        </Stack>
      </Stack>
    </Box>
  )
}
